/**
 * Helpers for citation source objects:
 * { start_page, end_page, start_bates_number?, end_bates_number?, filename?, verbatim? }
 */

export function getSourceJumpPage(source) {
  const page = source?.start_page;
  return typeof page === 'number' && Number.isFinite(page) ? page : 1;
}

/** Returns e.g. "(page 3)" or "(pages 3-5)", or "" if no start_page. */
export function formatSourcePageLabel(source) {
  if (source?.start_page == null) return '';
  const start = source.start_page;
  const end = source.end_page;
  if (end == null || end === start) {
    return `(page ${start})`;
  }
  return `(pages ${start}-${end})`;
}

/** Returns e.g. "(BATES001)" or "(BATES001–BATES003)", or "". */
export function formatSourceBatesLabel(source) {
  const start = source?.start_bates_number;
  const end = source?.end_bates_number;
  if (!start && !end) return '';
  if (start && end && start !== end) {
    return `(${start}–${end})`;
  }
  return `(${start || end})`;
}

/** Inclusive end page for download; defaults to start_page when end is missing. */
export function getSourceEndPage(source) {
  const start = source?.start_page;
  if (typeof start !== 'number' || !Number.isFinite(start)) return null;
  const end = source?.end_page;
  if (typeof end === 'number' && Number.isFinite(end)) return end;
  return start;
}

/** True when page-range download is supported for this source filename. */
export function isPdfSourceFileName(fileName) {
  return /\.pdf$/i.test(fileName ?? '');
}

export function buildSourcePagesDownloadUrl(caseId, fileName, startPage, endPage) {
  const params = new URLSearchParams({
    start: String(startPage),
    end: String(endPage),
  });
  return `/api/documents/${caseId}/${fileName}/pages?${params.toString()}`;
}

export function downloadSourcePageRange(caseId, fileName, source) {
  const startPage = getSourceJumpPage(source);
  const endPage = getSourceEndPage(source);
  if (endPage == null || !caseId || !fileName) return;
  const url = buildSourcePagesDownloadUrl(caseId, fileName, startPage, endPage);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = '';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
